import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Sectors = () => {
  const { t } = useLanguage();
  const iconMap = ["fa-hammer", "fa-scale-balanced", "fa-house-chimney-window", "fa-cart-shopping", "fa-stethoscope", "fa-user-tie", "fa-calculator", "fa-utensils"];
  const sectors = t.sectors.items.map((item, index) => ({
    ...item,
    icon: iconMap[index]
  }));

  return (
    <section id="sectors" className="py-24 px-6 bg-[#050505] relative">
      <div className="pexadia-watermark"></div>
      <div className="max-w-7xl mx-auto relative z-20">
        <div className="text-center mb-20">
          <div className="inline-block px-4 py-1.5 mb-6 border border-[#d4af37]/30 rounded-full bg-[#d4af37]/5">
            <span className="text-[10px] font-black tracking-[0.2em] gold-gradient uppercase">
              {t.sectors.badge}
            </span>
          </div>
          <h2 className="text-5xl md:text-7xl font-serif mb-6 italic">
            {t.sectors.title1} <span className="gold-gradient">{t.sectors.title2}</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-xl font-light leading-relaxed">
            {t.sectors.description}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {sectors.map((sector, index) => (
            <div key={index} className="glass-card rounded-[2rem] p-8 hover:border-[#d4af37]/40 transition-all relative">
              {/* Icône en haut à gauche */}
              <div className="absolute top-6 left-6 w-12 h-12 flex items-center justify-center">
                <i className={`fas ${sector.icon} text-[#d4af37] text-2xl`}></i>
              </div>
              
              {/* Impact Moyen en haut à droite */}
              <div className="text-right mb-4">
                <div className="text-xs font-black uppercase tracking-widest text-white mb-1">
                  {t.sectors.impact}
                </div>
                <div className="text-2xl font-bold gold-gradient">{sector.gain}</div>
              </div>
              
              {/* Titre de la profession */}
              <h3 className="text-xl font-bold text-white mb-3 mt-8">{sector.role}</h3>
              
              {/* Badge avec le sous-titre */}
              <div className="inline-block px-3 py-1 mb-4 bg-gray-800/50 rounded-lg border border-[#d4af37]/20">
                <span className="text-xs font-bold uppercase tracking-widest gold-gradient">
                  {sector.task}
                </span>
              </div>
              
              {/* Description */}
              <p className="text-gray-300 leading-relaxed font-light text-sm">{sector.detail}</p>
            </div>
          ))}
        </div>

        {/* Section "Votre métier n'est pas listé ?" */}
        <div className="mt-20 mb-16">
          <div className="glass-card rounded-[3rem] p-12 md:p-16 text-center border-[#d4af37]/20">
            <h3 className="text-4xl md:text-5xl font-serif mb-6 italic text-white">
              {t.sectors.notListed.title}
            </h3>
            <p className="text-gray-300 max-w-2xl mx-auto text-lg font-light leading-relaxed mb-8">
              {t.sectors.notListed.description}
            </p>
            <Link 
              to="/contact"
              className="inline-flex items-center gap-3 px-8 py-5 gold-bg text-black font-black rounded-full hover:scale-105 transition-transform uppercase tracking-widest text-xs shadow-xl shadow-gold/20"
            >
              {t.sectors.notListed.cta}
              <i className="fas fa-cog"></i>
            </Link>
          </div>
        </div>

        <div className="text-center">
          <Link 
            to="/contact"
            className="inline-block px-8 py-5 glass-card text-white font-bold rounded-full hover:bg-white/5 transition-colors uppercase tracking-widest text-xs border border-white/10"
          >
            {t.sectors.cta}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Sectors;

